import { atom } from 'recoil';

export const aiModalOpenAtom = atom({
  key: 'aiModalOpenAtom',
  default: false,
});

export const aiModalOpenAtomGlobal = atom({
  key: 'aiModalOpenAtomGlobal',
  default: false,
});
